import { FILE_SOURCES } from "layout/documentUploader/constants";
import { useSelector } from "react-redux";
import { selectSelectedCollection } from "slices/collections/selectors";
import { selectActiveSource } from "slices/workspace/selectors";

const Placeholder = () => {
  const activeSource = useSelector(selectActiveSource);
  const selectedCollection = useSelector(selectSelectedCollection);

  return (
    <div className="choose_files_modal__body__details__placeholder">
      {activeSource === FILE_SOURCES.COLLECTIONS && selectedCollection === null
        ? "To make a collection, start by selecting Local files"
        : "No files added yet"}
    </div>
  );
};

export default Placeholder;
